import Man from '../Assets/images/utyutyu.png';
import {
    useParams
} from "react-router-dom";
import axios from 'axios';
import { votesAbi, votesAddress, url, tokenAddress, tokenAbi } from "../config";
import React, { useEffect, useState } from "react";
import { RotatingLines } from "react-loader-spinner";
import { useAccount, useNetwork, useSigner } from "wagmi";
import { ethers } from "ethers";


function Proposals() {
    let { id } = useParams();
    const { isConnected, address } = useAccount();

    const { data: signer } = useSigner();
    const [proposal, setProposal] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const { chain } = useNetwork()
    const [approved, setApproved] = useState(false);

    const fetch = async () => {
        axios.get(`${url}/getProposal/${id}`).then((res) => {
            setProposal(res.data);
        })

    }

    useEffect(() => {
        if (isConnected && !chain?.unsupported && signer && address) {
            fetch().then(() => {
                console.log("Fetched")
            }).catch((e) => {
                console.log(e)
            })
            checkApproval().then((res) => {
                console.log(res)
            }
            ).catch((e) => {
                console.log(e)
            }
            )
        }
    }, [signer])

    const checkApproval = async () => {
        const contract = new ethers.Contract(tokenAddress[chain.id], tokenAbi, signer);
        const allowance = await contract.allowance(address, votesAddress[chain.id]);
        console.log(allowance)
        if (allowance.gt(0)) {
            setApproved(true);
        }
    }

    const approve = async () => {
        try {
            setLoading(true);
            const contract = new ethers.Contract(tokenAddress[chain.id], tokenAbi, signer);
            const tx = await contract.approve(votesAddress[chain.id], ethers.constants.MaxUint256);
            const res = await tx.wait();
            if (res.status === 1) {
                console.log("Approve success")
                setApproved(true);
            }
        } catch (err) {
            console.error(err);
            if (err.reason) {
                alert(err.reason);
            }
        } finally {
            setLoading(false);
        }
    }

    const vote = async (vote) => {
        try {
            setLoading(true);
            const contract = new ethers.Contract(votesAddress[chain.id], votesAbi, signer);
            const tx = await contract.vote(id, 1, vote);
            const res = await tx.wait();
            if (res.status === 1) {
                console.log("Vote success")
                fetch();
            }
        } catch (err) {
            console.error(err);
            if (err.reason) {
                alert(err.reason);
            }
        } finally {
            setLoading(false);
        }
    }
    return (
        <div className="container">
            <div className="row pb_50">
                <div className="col-12">
                <a class="Q_Card">
                    <div class="row">
                        <div class="col-12 col-md-2 col-sm-12 leftImgsSec">
                            <div class="walletPic ">
                                <img src={Man} alt="Man" />
                            </div>
                        <div class="Q_Closed ml-auto">{proposal.expired ?"Executed" : "Active"}</div>
                        </div>
                        <div class="col-12 col-md-10 col-sm-12 mt-20 rightImgsSec">
                            <div class="Q_head">
                                <div class="walletId mr-2">{proposal.creator}</div>
                                <div class="Q_tag__ mr-2">Core</div>
                            </div>
                            <div class="Q_body">
                                <h4>{proposal.title}</h4>
                                <p>{proposal.description}</p>
                            </div>
                            <div className="Q_bottom">
                            <div className="answer__">Yes - I agree with the proposal (1000 FND) <span className="vCount ml-2">{proposal.yes_votes}</span> <span className="ml-auto">{proposal.percent}</span>
                                <div className="progressBar" style={{ width: proposal.percent + "%" }} ></div>
                            </div>
                            <div className="answer__">No - I reject the proposal (1000 FND) <span className="vCount ml-2">{proposal.no_votes}</span> <span className="ml-auto">{100 - proposal.percent}</span>
                                <div className="progressBar" style={{ width: 100 - proposal.percent + "%" }} ></div>
                            </div>
                        </div>
                       {!proposal.expired && <div class="yesNo-btn">
                            {!approved ? (<>
                                <button disabled={loading} onClick={() => approve()} className="Q_Closed active button">Approve FND before voting</button>
                            </>) :
                                (<div>
                                    <button disabled={loading} onClick={() => vote(true)} className="Q_Closed active button">{loading ? <RotatingLines height={15} width={15} /> : ""}{"Yes (Burn 1000 FND)"}</button>
                                    <button disabled={loading} onClick={() => vote(false)} className="Q_Closed">{loading ? <RotatingLines height={15} width={15} /> : ""}No (Burn 1000 FND)</button>
                                </div>)}
                        </div>}
                          
                        </div>
                    </div>
                </a>
                    {/* <a className="Q_Card">
                        <div className="Q_head">
                            <div className="walletPic mr-2"><img src={Man} alt="Man" /></div>
                            <div className="walletId mr-2">{proposal.creator}</div>
                            <div className="Q_tag__ mr-2">Core</div>
                            <div className="Q_Closed ml-auto">{"Active"}</div>
                        </div>
                        <div className="Q_body">
                            <h4>{proposal.title}</h4>
                            <p>{proposal.description}</p>
                        </div>
                        <div className="Q_bottom">
                            <div className="answer__">Yes - I agree with the proposal (1000 FND) <span className="vCount ml-2">{proposal.yes_votes}</span> <span className="ml-auto">{proposal.percent}</span>
                                <div className="progressBar" style={{ width: proposal.percent + "%" }} ></div>
                            </div>
                            <div className="answer__">No - I reject the proposal (1000 FND) <span className="vCount ml-2">{proposal.no_votes}</span> <span className="ml-auto">{100 - proposal.percent}</span>
                                <div className="progressBar" style={{ width: 100 - proposal.percent + "%" }} ></div>
                            </div>
                        </div>
                        <div class="yesNo-btn">
                            {!approved ? (<>
                                <button disabled={loading} onClick={() => approve()} className="Q_Closed active button">Approve FND before voting</button>
                            </>) :
                                (<div>
                                    <button disabled={loading} onClick={() => vote(true)} className="Q_Closed active button">{loading ? <RotatingLines height={15} width={15} /> : ""}{"Yes (Burn 1000 FND)"}</button>
                                    <button disabled={loading} onClick={() => vote(false)} className="Q_Closed">{loading ? <RotatingLines height={15} width={15} /> : ""}No (Burn 1000 FND)</button>
                                </div>)}
                        </div>
                    </a> */}
                </div>
            </div>

        </div>
    )
}

export default Proposals